/**
 * Module-level initialization — runs ONCE before any React component mounts.
 * Clears stale exam data from localStorage so that ExamProvider never reads previous user's answers.
 */

import { examUrlParams } from "./utils/urlParams";
import { clearStaleExamData, scheduleIndexedDBCleanup } from "./utils/examStorageCleaner";

const { isDemoExam, uprId } = examUrlParams;

if (!isDemoExam && uprId) {
  const didClear = clearStaleExamData(uprId);
  if (didClear) {
    scheduleIndexedDBCleanup();
  }
}
